import { useState } from "react";

export function useRemount(): [key: number, remount: () => void] {
	const [key, setKey] = useState(0);
	const remount = () => setKey((prevKey) => prevKey + 1);
	return [key, remount];
}
